import React, { useEffect, useState } from "react";
import { API } from "../../constants/Api";
import "./SectionSix.css";
function SectionSix() {
  const [advertisers, setAdvertisers] = useState([]);
  const [filteredAdvertisers, setFilteredAdvertisers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [visibleCount, setVisibleCount] = useState(4);

  const fetchFeaturedAdvertisers = async () => {
    try {
      const response = await fetch(
        `${API}/advertiser/get-featured-advertisers`
      );
      if (response.ok) {
        const result = await response.json();
        setAdvertisers(result?.advertisers);
        setFilteredAdvertisers(result?.advertisers);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchFeaturedAdvertisers();
  }, []);

  // Handle search functionality
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = advertisers.filter(
      (advertiser) =>
        advertiser.fulName.toLowerCase().includes(value) ||
        advertiser.featuredZipcodes.some((zip) => zip.includes(value))
    );

    setFilteredAdvertisers(filtered);
    setVisibleCount(4); // Reset Load More when searching
  };
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="section-six">
      <div className="container-fluid section-six-content">
        <div className="container-fluid section-six-container">
          {
            isMobile?
            <>
              <div className="row px-0 mx-0">
              <div className="col-12">
              <p className="section-six-heading">
                Featured <span className="bold-content">Service Providers</span>
              </p>
              </div>
            </div>
            <div className="row px-0 mt-3 mx-0">
              <div className="col-12 px-3 mx-0">
              <div
                className="input-group table-search-input-group-mobile-2 d-flex align-items-center"
               
              >
                <img
                  src="/img/gold-search-icon.svg"
                  className="img-fluid table-search-icon-mobile-2"
                  // id="mobile-search-icon"
                  alt=""
                />
                <input
                  type="text"
                  className="table-search-input-2-mobile"
                  // id="mobile-search-icon-input"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </div>
              </div>
            </div>
            </>
          
            :
            <div className="row px-0 mx-0">
            <div className="col-6" id="mobile-margin">
              <p className="section-six-heading">
                Featured <span className="bold-content">Service Providers</span>
              </p>
            </div>
            <div
              className="col-6 d-flex justify-content-end mobile-search"
              style={{ position: "absolute", zIndex: "9999", right: "50px" }}
            >
              <div
                className="input-group table-search-input-group d-flex justify-content-end align-items-center"
                id="mobile-main-search-bar"
              >
                <img
                  src="/img/gold-search-icon.svg"
                  className="img-fluid table-search-icon"
                  id="mobile-search-icon"
                  alt=""
                />
                <input
                  type="text"
                  className="table-search-input-2"
                  id="mobile-search-icon-input"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </div>
            </div>
          </div>
          }
   
          <div className="row px-0 mx-0 mt-4">
            {/* {filteredAdvertisers
              .slice(0, visibleCount)
              .map((advertiser, index) => ( */}
            {/* <div className={`col-md-6 ${index >= 2 ? "py-4" : ""}`}> */}
            <div className={`col-md-6`}>
              <div className="card section-six-card1">
                <div className="card-body">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-3 rounded-circle">
                        <img
                          src="/img/vendor-1.svg"
                          className="img-fluid section-six-profile-image rounded-circle"
                          alt=""
                        />
                      </div>
                      <div className="col-md-9 d-flex align-items-start flex-column justify-content-center gap-2 section-six-card-mobile">
                        <span className="badge section-six-card1-badge">
                          Vendor
                        </span>
                        <span className="section-six-card1-name">
                          Matt Laricy
                        </span>
                        <span className="section-six-card1-desc-1">
                          Americorp Real Estate
                        </span>
                        <span className="section-six-card1-desc-2">
                          47 W 13th St, New York, NY 10011, USA
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* ))} */}
            <div className="col-md-6">
              <div className="card section-six-card1 section-six-mobile-card2">
                <div className="card-body">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-3">
                        <img
                          src="/img/vendor-2.svg"
                          className="img-fluid section-six-profile-image"
                          alt=""
                        />
                      </div>
                      <div className="col-md-9 d-flex align-items-start flex-column justify-content-center gap-2 section-six-card-mobile">
                        <span className="badge section-six-card2-badge">
                          Service Provider
                        </span>
                        <span className="section-six-card1-name">
                          Patrick Shino | The SK Group
                        </span>
                        <span className="section-six-card1-desc-1">
                          Home Inspection
                        </span>
                        <span className="section-six-card1-desc-2">
                          47 W 13th St, New York, NY 10011, USA
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 py-4">
              <div className="card section-six-card1">
                <div className="card-body">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-3">
                        <img
                          src="/img/vendor-3.svg"
                          className="img-fluid section-six-profile-image"
                          alt=""
                        />
                      </div>
                      <div className="col-md-9 d-flex align-items-start flex-column justify-content-center gap-2 section-six-card-mobile">
                        <span className="badge section-six-card1-badge">
                          Service Provider
                        </span>
                        <span className="section-six-card1-name">
                          Bari Lavine
                        </span>
                        <span className="section-six-card1-desc-1">
                          Insurance Agent
                        </span>
                        <span className="section-six-card1-desc-2">
                          47 W 13th St, New York, NY 10011, USA
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 py-4">
              <div className="card section-six-card1 section-six-mobile-card4">
                <div className="card-body">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-3">
                        <img
                          src="/img/vendor-4.svg"
                          className="img-fluid section-six-profile-image"
                          alt=""
                        />
                      </div>
                      <div className="col-md-9 d-flex align-items-start flex-column justify-content-center gap-2 section-six-card-mobile">
                        <span className="badge section-six-card2-badge">
                          Service Provider
                        </span>
                        <span className="section-six-card1-name">
                          Sam Shaffer
                        </span>
                        <span className="section-six-card1-desc-1">
                          Home Security System
                        </span>
                        <span className="section-six-card1-desc-2">
                          47 W 13th St, New York, NY 10011, USA
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* {visibleCount < filteredAdvertisers.length && ( */}
          <div className="row px-0 mx-0">
            <div className="col-12">
              <button
                className="btn w-100 section-six-cta"
                // onClick={() => setVisibleCount((prev) => prev + 4)}
              >
                Show All
              </button>
            </div>
          </div>

          {/* {visibleCount < filteredAdvertisers.length && (
            <div className="row px-0 mx-0">
              <div className="col-12">
                <button
                  className="btn w-100 section-six-cta"
                  onClick={() => setVisibleCount((prev) => prev + 4)}
                >
                  Show All
                </button>
              </div>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
}

export default SectionSix;
